export const ROLE_LABEL = {
  super_admin: "Super Admin",
  ops_admin: "Operations Admin",
  shipper: "Shipper",
  carrier_owner: "Carrier Owner",
  dispatcher: "Dispatcher",
  driver: "Driver",
};

export const STATUS_LABEL = {
  draft: "Draft",
  published: "Published",
  assigned: "Assigned",
  started: "Started",
  picked_up: "Picked Up",
  in_transit: "In Transit",
  delivered: "Delivered",
  closed: "Closed",
};

export const EQUIPMENT_LABEL = {
  van: "Dry Van",
  reefer: "Reefer",
  flatbed: "Flatbed",
  stepdeck: "Step Deck",
  tanker: "Tanker",
};

export function fmtMoney(v) {
  if (v == null) return "—";
  return "$" + Number(v).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export function fmtDate(s) {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  } catch { return s; }
}

export function fmtDateTime(s) {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return s; }
}
